export enum StateId {
    NY = 1,
    NH = 2,
    LA = 3,
    HI = 4,
    TX = 5,
    MP = 6,
    MH = 7,
    GA = 8,
    AS = 9,
    MS = 11,
    MA = 12,
    KY = 13,
    IA = 14,
    MI = 15,
    AZ = 16,
    PW = 17,
    VA = 18,
    OH = 19,
    AR = 20,
    MN = 21,
    CT = 22,
    FL = 23,
    DE = 24,
    WV = 25,
    FM = 26,
    MO = 27,
    AK = 28,
    OR = 29,
    ND = 30,
    PR = 31,
    RI = 32,
    AL = 33,
    WY = 34,
    ID = 35,
    MD = 36,
    IL = 37,
    WI = 38,
    NM = 39,
    NV = 40,
    PA = 41,
    GU = 42,
    NE = 43,
    WA = 44,
    ME = 45,
    TN = 46,
    CO = 47,
    SC = 48,
    NJ = 49,
    NC = 50,
    KS = 51,
    DC = 52,
    IN = 53,
    CA = 54,
    OK = 55,
    UT = 56,
    MT = 57,
    VT = 58,
    SD = 59,
    VI = 654,
    AE = 655,
    AA = 656,
    AP = 657
}